import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { List, WingBlank } from 'antd-mobile'
import CardLayout from '../../components/common/CardLayout'
import { removeDmFile, removeDmInsFile, uploadDmFile, uploadInsDmFile } from '../../reducers/ui'
import UploadOssFile from '../../components/common/UploadOssFile'
import UploadFileWrapper from '../../components/common/UploadFileWrapper'
import UploadEfrOrEfri from '../../components/common/UploadEfrOrEfri'

const Item = List.Item

const RequiredCerts = ({ aow, efr, rescue, aowFiles, efrfiles, rescueFiles, efri, isInstructor, editable }) => {
  const dispatch = useDispatch()
  const status =
    (aow || aowFiles.length > 0) && (rescue || rescueFiles.length > 0) && (efr || efrfiles.length > 0 || efri)

  const { ossSignature } = useSelector((state) => ({
    ossSignature: state.oss.ossSignature,
  }))

  const deleteCert = (index, files) => {
    if (isInstructor) {
      dispatch(removeDmInsFile(files[index]))
      return
    }
    dispatch(removeDmFile(files[index]))
  }

  const uploadFile = (formData) => {
    if (isInstructor) {
      dispatch(uploadInsDmFile({ formData }))
      return
    }
    dispatch(uploadDmFile({ formData }))
  }

  return (
    <CardLayout title={<FormattedMessage id="dm-form-required-certs" />} status={status}>
      {aow ? (
        <Item>{`AOW (${aow.studentNumber})`}</Item>
      ) : (
        <UploadFileWrapper labelName={'AOW'} editable={editable}>
          <UploadOssFile
            fileList={aowFiles || []}
            editable={editable}
            type={'AOW'}
            fileName={`${ossSignature.dir}AOW/${new Date().getTime()}`}
            onChange={(formData) => {
              uploadFile(formData)
            }}
            onDelete={(index) => deleteCert(index, aowFiles)}
          />
          {editable && (
            <WingBlank>
              <div className="small-font gray">
                <FormattedMessage id="common-upload-file-reminder" />
              </div>
            </WingBlank>
          )}
        </UploadFileWrapper>
      )}
      {rescue ? (
        <Item>{`RESCUE (${rescue.studentNumber})`}</Item>
      ) : (
        <UploadFileWrapper labelName={'RESCUE'} editable={editable}>
          <UploadOssFile
            fileList={rescueFiles || []}
            editable={editable}
            type={'RESCUE'}
            fileName={`${ossSignature.dir}RESCUE/${new Date().getTime()}`}
            onChange={(formData) => {
              uploadFile(formData)
            }}
            onDelete={(index) => deleteCert(index, rescueFiles)}
          />
          {editable && (
            <WingBlank>
              <div className="small-font gray">
                <FormattedMessage id="common-upload-file-reminder" />
              </div>
            </WingBlank>
          )}
        </UploadFileWrapper>
      )}
      <UploadEfrOrEfri
        uploadFn={(formData) => {
          uploadFile(formData)
        }}
        removeFn={(index) => deleteCert(index, efrfiles)}
        filename={`${ossSignature.dir}EFR/${new Date().getTime()}`}
        editable={editable}
        efrfiles={efrfiles}
      />
    </CardLayout>
  )
}

export default RequiredCerts
